"use client";

import { c as _c } from "react/compiler-runtime";
import { List, Archive, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ViewMode } from "@/stores/use-todo-store";
export interface SidebarProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}
export function Sidebar(t0) {
  const $ = _c(46);
  const {
    viewMode,
    onViewModeChange,
    isCollapsed,
    onToggleCollapse
  } = t0;
  const t1 = isCollapsed ? "w-14" : "w-48";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-col gap-1 p-2 border-r border-border bg-background transition-all duration-200", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = viewMode === "daily" ? "secondary" : "ghost";
  const t4 = isCollapsed ? "justify-center px-2" : "justify-start";
  const t5 = viewMode === "daily" && "bg-secondary";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = cn("w-full gap-2", t4, t5);
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onViewModeChange) {
    t7 = () => onViewModeChange("daily");
    $[5] = onViewModeChange;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = isCollapsed ? "Daily Tasks" : undefined;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <List className="w-5 h-5 flex-shrink-0" />;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== isCollapsed) {
    t10 = !isCollapsed && <span>Daily Tasks</span>;
    $[8] = isCollapsed;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t3 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t11 = <Button variant={t3} className={t6} onClick={t7} title={t8}>{t9}{t10}</Button>;
    $[10] = t10;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = viewMode === "archive" ? "secondary" : "ghost";
  const t13 = isCollapsed ? "justify-center px-2" : "justify-start";
  const t14 = viewMode === "archive" && "bg-secondary";
  let t15;
  if ($[16] !== t13 || $[17] !== t14) {
    t15 = cn("w-full gap-2", t13, t14);
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== onViewModeChange) {
    t16 = () => onViewModeChange("archive");
    $[19] = onViewModeChange;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = isCollapsed ? "Archive" : undefined;
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Archive className="w-5 h-5 flex-shrink-0" />;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== isCollapsed) {
    t19 = !isCollapsed && <span>Archive</span>;
    $[22] = isCollapsed;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t12 || $[25] !== t15 || $[26] !== t16 || $[27] !== t17 || $[28] !== t19) {
    t20 = <Button variant={t12} className={t15} onClick={t16} title={t17}>{t18}{t19}</Button>;
    $[24] = t12;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t11 || $[31] !== t20) {
    t21 = <div className="flex flex-col gap-1 flex-1">{t11}{t20}</div>;
    $[30] = t11;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = isCollapsed ? "justify-center px-2" : "justify-start";
  let t23;
  if ($[33] !== t22) {
    t23 = cn("w-full mt-auto", t22);
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  const t24 = isCollapsed ? "Expand sidebar" : "Collapse sidebar";
  let t25;
  if ($[35] !== isCollapsed) {
    t25 = isCollapsed ? <CaretRight className="w-4 h-4" /> : <><CaretLeft className="w-4 h-4" /><span className="ml-2 text-xs">Collapse</span></>;
    $[35] = isCollapsed;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== onToggleCollapse || $[38] !== t23 || $[39] !== t24 || $[40] !== t25) {
    t26 = <Button variant="ghost" size="sm" className={t23} onClick={onToggleCollapse} title={t24}>{t25}</Button>;
    $[37] = onToggleCollapse;
    $[38] = t23;
    $[39] = t24;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t2 || $[43] !== t21 || $[44] !== t26) {
    t27 = <div className={t2}>{t21}{t26}</div>;
    $[42] = t2;
    $[43] = t21;
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  return t27;
}